<template>
  <div class="quote-text">
    <div class="grid md:grid-cols-12 p-6 lg:py-20 gap-8">
      <div class="col-span-12 flex justify-center mb-8">
        <div class="quote-image-container relative bg-transparent p-10 lg:p-15 rounded-sm">
          <div
            class="quote-text-image bg-no-repeat bg-cover h-full w-full"
            :style="{ backgroundImage: `url(${quoteImgPlaceholder})` }"
          >
            <ShieldMaskFullRotated />
          </div>
        </div>
      </div>

      <div :class="{ 'md:order-1': !showTextOnLeftSide, 'md:order-2': showTextOnLeftSide, 'col-span-5 z-10': true }">
        <div class="flex h-full w-full justify-center items-center">
          <div class="quote-container relative bg-transparent p-10 lg:p-15 rounded-sm">
            <div class="quote-wrapper relative h-full">
              <p class="quote-text-content relative text-xl lg:text-4xl font-playfair font-bold mb-4 text-primary-alpha z-10">
                {{ quoteContent }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="relative z-[1]"
        :class="{ 'md:order-1': !showTextOnLeftSide, 'md:order-2': showTextOnLeftSide, 'col-span-7': true }"
      >
        <kf-rich-text>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div v-html="richText" />
        </kf-rich-text>
        <KfButtonContainer
          :button-container-links="links"
          :button-container-position-horizontal="btnAlignmentHorizontal"
        />
      </div>
    </div>
  </div>
</template>


<script>
import KfRichText from '@/components/base/rich-text/RichText.vue';
import KfButtonContainer from '@/components/button-container/ButtonContainer.vue';
export default {
  name: 'KfQuoteText',
  components: {
    KfButtonContainer,
    KfRichText,
    ShieldMaskFullRotated: () =>
      import(/* webpackChunkName: "main"*/ '@/components/svg/ShieldMaskFullRotated.vue'),
  },
  props: {
    quoteContent: {
      type: String,
      default: () => '',
    },
    richText: {
      type: String,
      default: () => '',
    },
    links: {
      type: Array,
      default: () => [],
    },
    showTextOnLeftSide: {
      type: Boolean,
      default: () => true,
    },
    btnAlignmentHorizontal: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      quoteImgPlaceholder: require('@/assets/svg/quote-image-placeholder.svg?inline'),
    };
  },
};
</script>


<style lang="postcss">
.quote-text {
  .quote-container {
    overflow: visible;
    height: auto;
  }

  .quote-wrapper {
    position: relative;
    height: 100%;
  }

  .quote-text-content {
    position: relative;
    z-index: 10;
    font-size: 2rem;
    font-weight: 100;
  }

  .quote-image-container {
    overflow: visible;
    height: auto;
    position: absolute;
    left: -100px;
    width: 100%;
  }

  .quote-text-image {
    position: relative;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    width: 100%;
    height: 400px;
  }

  @media (min-width: 768px) {
    .quote-image-container {
      left: -200px;
    }
  }

  @media (min-width: 1024px) {
    .quote-image-container {
      left: -300px;
    }
  }

  @media (min-width: 1280px) {
    .quote-image-container {
      left: -460px;
    }
  }
}
</style>
